'use strict';

var utils = require('../utils');

module.exports = function () {
    $('body').on('product:beforeAddToCart pur:beforeAddToCart', function () {
        // Injecting add to cart modal css after add to cart clicked
        let $atcModalPath = $('#atc-modal-path');
        if ($atcModalPath.length && !$atcModalPath.data('loaded')) {
            utils.injectDynamicCss($atcModalPath.data('csspath'));
            $atcModalPath.data('loaded', true);
        }
    });

    $('body').on('product:beforeChangeStore', function () {
        // Injecting change store modal css
        let $storeModalPath = $('#change-store-path');
        if ($storeModalPath.length && !$storeModalPath.data('loaded')) {
            utils.injectDynamicCss($storeModalPath.data('csspath'));
            $storeModalPath.data('loaded', true);
        }
    });

    $('body').on('product:beforeRecommendationsLoad', function () {
        // Injecting recommondation tiles CSS
        let $recommendationPath = $('#recommendation-path');
        if ($recommendationPath.length && !$recommendationPath.data('loaded')) {
            utils.injectDynamicCss($recommendationPath.data('csspath'));
            $recommendationPath.data('loaded', true);
        }
    });

    $('body').on('product:beforeHomeRecommendationsLoad', function () {
        // Injecting home page recommendation tiles CSS
        let $recommendationPath = $('#home-recommendation-path');
        if ($recommendationPath.length && !$recommendationPath.data('loaded')) {
            utils.injectDynamicCss($recommendationPath.data('csspath'));
            $recommendationPath.data('loaded', true);
        }
    });

    $('body').on('product:beforeAccountModalLoad', function () {
        // Injecting home page recommendation tiles CSS
        let $recommendationPath = $('#account-modal-path');
        if ($recommendationPath.length && !$recommendationPath.data('loaded')) {
            utils.injectDynamicCss($recommendationPath.data('csspath'));
            $recommendationPath.data('loaded', true);
        }
    });

    $('body').on('product:beforeMinicartLoads', function () {
        // Injecting minicart CSS
        let $miniCartCss = $('#mini-cart-path');
        if ($miniCartCss.length && !$miniCartCss.data('loaded')) {
            utils.injectDynamicCss($miniCartCss.data('csspath'));
            $miniCartCss.data('loaded', true);
        }
    });

    $('body').on('product:beforeFooterLoads', function () {
        // Injecting footer CSS
        let $footerCss = $('#footer-path');
        if ($footerCss.length && !$footerCss.data('loaded')) {
            utils.injectDynamicCss($footerCss.data('csspath'));
            $footerCss.data('loaded', true);
        }
    });

    $('body').on('product:beforeSuggestionsLoads', function () {
        // Injecting search suggestions CSS
        let $suggestionsCss = $('#search-suggestion-path');
        if ($suggestionsCss.length && !$suggestionsCss.data('loaded')) {
            utils.injectDynamicCss($suggestionsCss.data('csspath'));
            $suggestionsCss.data('loaded', true);
        }
    });

    $('body').on('product:beforeVerifySDDLoads', function () {
        // Injecting SDD verify Address modal CSS
        let $sddCss = $('#sdd-verify-path');
        if ($sddCss.length && !$sddCss.data('loaded')) {
            utils.injectDynamicCss($sddCss.data('csspath'));
            $sddCss.data('loaded', true);
        }
    });

    $('body').on('product:beforehomeProductTileLoads', function () {
        // Injecting Home Product Tile CSS
        let $homeProductTileCss = $('#home-page-product-tile');
        if ($homeProductTileCss.length && !$homeProductTileCss.data('loaded')) {
            utils.injectDynamicCss($homeProductTileCss.data('csspath'));
            $homeProductTileCss.data('loaded', true);
        }
    });

    $('body').on('product:preownedGuaranteeCssLoads', function () {
        // Injecting Preowned Guarantee CSS
        let $preownedGuaranteeCss = $('#preowned-guarantee');
        if ($preownedGuaranteeCss.length && !$preownedGuaranteeCss.data('loaded')) {
            utils.injectDynamicCss($preownedGuaranteeCss.data('csspath'));
            $preownedGuaranteeCss.data('loaded', true);
        }
    });

    $('body').on('product:beforePlpRecommendationsLoad', function () {
        let $plpRecommendationsCss = $('#plp-recommendations');
        if ($plpRecommendationsCss.length && !$plpRecommendationsCss.data('loaded')) {
            utils.injectDynamicCss($plpRecommendationsCss.data('csspath'));
            $plpRecommendationsCss.data('loaded', true);
        }
    });
};
